import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = [
  {
    path: '/ai-assistant',
    exact: true,
    page: getLoadablePage(() => import(/* webpackChunkName: "chat_canvas" */ '../pages/canvas-definition')),
    chunkName: 'chat_canvas',
  },
];
